import { css, styled } from '../theme';

export const Arrow = styled.div<{ $isShown: boolean }>`
  ${({ $isShown }) => css`
    transform: scale(${$isShown ? 1 : 0});
    transition-duration: 200ms;
    pointer-events: auto;
  `}
`;

export const ContentNavigation = styled.div`
  ${({ theme }) => css`
    position: sticky;
    top: ${theme.spacings.base};
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.spacings.xxl};
    height: fit-content;
    pointer-events: all;
  `}
`;

export const StyledAnchor = styled.div`
  position: absolute;
`;

export const PanelsWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    width: 650px;
    max-width: 85dvw;
    height: 100%;

    & > *:not(:first-child) {
      margin-top: 16px;
    }

    ${theme.tokens.media.down('desktop')} {
      max-width: unset;
    }
  `}
`;
